var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex border-bottom page-header"},[_c('p',{staticClass:"font-size-28 font-weight-light my-auto"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"my-auto ml-auto"},[_vm._t("actions")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }